
import React from "react";
import { Utils } from "../../../../utils";
import Pipeline from "./pipeline/Pipeline";
import { i18nManager } from "../../../../i18n";
import { IPlatform, IProfile } from "../../../../services";
import { DashboardContainer } from "../../../shared/DashboardContainer";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";

export interface CrmProps {
    search: string;
    profile: IProfile;
    platform?: IPlatform;
}

function Crm(props: CrmProps) {
    const loading = !props.platform;
    const [searchParams, _] = useSearchParams(window.location.search);
    const labels = i18nManager.Labels.dashboard.platform_management.crm;
    const search = Utils.urlParamsToSearch(searchParams, ["platform_id"]);

    return DashboardContainer({
        ...labels,
        search: props.search,
        title: (<React.Fragment>{labels.title} ({loading ? (<i className="fa fa-spinner fa-spin" />) : (props.platform?.platform_id ?? '')})</React.Fragment>),
        content: (<Routes>
            <Route path="/pipeline/*" element={<Pipeline platform={props.platform} />} />
            <Route path="/pipeline" element={<Navigate to={{ pathname: "/dashboard/crm/pipeline/leads", search }} />} />
        </Routes>),
    });
}

export default Crm;
